import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Breadcrumbs.module.css';

function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const breadcrumbNames = {
    'portfolio': 'Portfolio',
    'investment-criteria': 'Investment Criteria and Insights',
    'company-information': 'Company Information and Insights',
    'pressroom': 'Pressroom',
    'investment-philosophy': 'Investment Philosophy',
    'careers': 'Career Opportunities',
    'terms-conditions': 'Terms & Conditions',
    'privacy-policy': 'Privacy Policy',
    'disclaimer': 'Disclaimer',
    'cookie-policy': 'Cookie Policy'
  };

  // Show breadcrumbs for all pages including home
  const isHome = pathnames.length === 0;

  return (
    <nav className={styles.breadcrumbs}>
      <div className={styles.container}>
        {isHome ? (
          <span className={styles.currentPage}>Home</span>
        ) : (
          <>
            <Link to="/" className={styles.breadcrumbLink}>Home</Link>
            {pathnames.map((name, index) => {
              const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
              const isLast = index === pathnames.length - 1;
              const displayName = breadcrumbNames[name] || name;

              return (
                <span key={name} className={styles.breadcrumbItem}>
                  <span className={styles.separator}>›</span>
                  {isLast ? (
                    <span className={styles.currentPage}>{displayName}</span>
                  ) : (
                    <Link to={routeTo} className={styles.breadcrumbLink}>
                      {displayName}
                    </Link>
                  )}
                </span>
              );
            })}
          </>
        )}
      </div>
    </nav>
  );
}

export default Breadcrumbs;